/**
 * Copyright © Veeam Software Group GmbH.
 */

import { CloudTenantTypeRepresentation } from '@veeam-vspc/models/web-controllers';

export type CloudTenantType = CloudTenantTypeRepresentation;
export const CloudTenantType = CloudTenantTypeRepresentation;
